"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.from.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBriefLocation = exports.DEFAULT_SEARCH_LOCATION = exports.getSearchLocationForBriefLocation = exports.formatLocation = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.function.name.js");

var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));

var _toTitleCase = require("../transformers/toTitleCase");

var _state = require("../util/state");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/** takes an address object or string and returns a correctly-cased `city, state` string
 *
 * @example formatLocation({ city: 'Germantown', stateProvince: 'NY', ... }); // 'Germantown, NY'
 * @example formatLocation('germantown, ny'); // 'Germantown, NY'
 *
 */
var formatLocation = function formatLocation(location) {
  var _stateProvince;

  if (!location) return '';
  var city;
  var stateProvince;

  if (typeof location === 'string') {
    var matches = location.match(/(.+),\s*(.+)/);

    if (matches) {
      var _matches = _slicedToArray(matches, 3);

      city = _matches[1];
      stateProvince = _matches[2];
    } else if (location.length === 2) {
      stateProvince = location; // The string is probably a state code
    } else {
      city = location; // The string is probably a city
    }
  } else {
    city = location.city;
    stateProvince = location.stateProvince;
  }

  city = (0, _toTitleCase.toTitleCase)(city).trim();
  city = city.replace(/Mc([a-z])/i, function (_, captured) {
    return "Mc".concat((0, _capitalize2.default)(captured));
  });
  city = city.replace(/'([a-z]\S)/i, function (_, captured) {
    return "'".concat((0, _capitalize2.default)(captured));
  });
  city = city.replace(/\s([dl])'/i, function (_, captured) {
    return " ".concat(captured.toLowerCase(), "'");
  });
  stateProvince = (_stateProvince = stateProvince) === null || _stateProvince === void 0 ? void 0 : _stateProvince.toUpperCase().trim();
  return [city, stateProvince].filter(function (e) {
    return e;
  }).join(', ');
};

exports.formatLocation = formatLocation;

var getSearchLocationForBriefLocation = function getSearchLocationForBriefLocation(location) {
  return {
    type: 'CITY',
    label: formatLocation({
      city: location.name,
      stateProvince: location.stateCode
    }),
    slug: location.slug,
    stateSlug: (0, _state.getStateSlug)(location.stateCode),
    marketSlug: null,
    usCityId: null,
    storefrontSearchPayload: {
      vendorMarketId: location.vendorMarket.id,
      city: location.name,
      stateProvince: location.stateCode
    },
    geoCoordinates: null
  };
};

exports.getSearchLocationForBriefLocation = getSearchLocationForBriefLocation;
var DEFAULT_SEARCH_LOCATION = {
  name: 'New York',
  stateCode: 'NY',
  slug: 'new-york-ny',
  vendorMarket: {
    id: 3169
  }
};
exports.DEFAULT_SEARCH_LOCATION = DEFAULT_SEARCH_LOCATION;

var getBriefLocation = function getBriefLocation(weddingLocation) {
  if (weddingLocation) {
    var city = weddingLocation.city,
        stateProvince = weddingLocation.stateProvince,
        citySlug = weddingLocation.citySlug,
        vendorMarket = weddingLocation.vendorMarket;

    if (city && stateProvince && citySlug && vendorMarket !== null && vendorMarket !== void 0 && vendorMarket.id) {
      return {
        name: city,
        stateCode: stateProvince,
        slug: citySlug,
        vendorMarket: {
          id: vendorMarket.id
        }
      };
    }

    return DEFAULT_SEARCH_LOCATION;
  }

  return DEFAULT_SEARCH_LOCATION;
};

exports.getBriefLocation = getBriefLocation;